// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__jVJim","Cards-wrapper":"Cards_Cards-wrapper__hRDzj","card":"Cards_card__puCmt","icon-wrapper":"Cards_icon-wrapper__nqtsN"};